/*
 * Realce de JSON sem `v-html`.
 *
 * O payload vem de fora — do ERP, do RD Station, de qualquer serviço que nos
 * chame — e por isso não pode ser injetado como HTML. A função devolve pedaços
 * `{ texto, classe }` para o template renderizar com `v-for`, que escapa cada
 * um deles.
 *
 * As classes (`j-key`, `j-str`, `j-bool`, `j-num`, `j-punc`) são estilizadas
 * por quem usa; nasceram na tela de logs de integração e servem igual a
 * qualquer preview de payload.
 */

const RE_JSON = /("(?:\\.|[^"\\])*"\s*:)|("(?:\\.|[^"\\])*")|\b(true|false|null)\b|(-?\d+\.?\d*)/g;

/**
 * @param {string} texto  JSON já formatado (com quebras de linha)
 * @param {string} filtro quando preenchido, mantém só as linhas que o contêm
 */
export function tokensJson(texto, filtro) {
  let json = String(texto == null ? '' : texto);

  if (filtro && filtro.trim()) {
    const termo = filtro.trim().toLowerCase();
    const mantidas = json.split('\n').filter((linha) => linha.toLowerCase().includes(termo));
    json = mantidas.length
      ? mantidas.join('\n')
      : `// nenhuma linha contém "${filtro.trim()}"`;
  }

  const tokens = [];
  const regex = new RegExp(RE_JSON.source, 'g');
  let ultimo = 0;
  let achado;

  while ((achado = regex.exec(json)) !== null) {
    if (achado.index > ultimo) {
      tokens.push({ texto: json.slice(ultimo, achado.index), classe: 'j-punc' });
    }

    let classe = 'j-punc';
    if (achado[1]) {
      classe = 'j-key';
    } else if (achado[2]) {
      classe = 'j-str';
    } else if (achado[3]) {
      classe = 'j-bool';
    } else if (achado[4]) {
      classe = 'j-num';
    }

    tokens.push({ texto: achado[0], classe });
    ultimo = regex.lastIndex;
  }

  if (ultimo < json.length) {
    tokens.push({ texto: json.slice(ultimo), classe: 'j-punc' });
  }

  return tokens;
}

/**
 * Formata para leitura o que chegou como texto: JSON válido ganha indentação,
 * o resto volta como está — melhor mostrar o texto cru do que esconder.
 */
export function formataJson(bruto) {
  if (bruto == null || bruto === '') {
    return '';
  }

  try {
    return JSON.stringify(JSON.parse(bruto), null, 2);
  } catch (e) {
    return String(bruto);
  }
}

export default tokensJson;
